export const caseStudies = [
  {
    id: 1,
    title: "Apex Realty Group",
    category: "Real Estate Agency",
    tag: "Concept Work",
    description: "A complete digital overhaul for a mid-sized real estate firm. We redesigned their outdated site into a sleek, conversion-focused platform with property search, lead capture, and agent profiles.",
    beforeIcon: "ri-layout-grid-line",
    afterIcon: "ri-home-4-line",
    metrics: [
      { label: "Lead Increase", value: "+240%" },
      { label: "Bounce Rate Drop", value: "-62%" },
      { label: "Load Speed", value: "0.8s" },
    ],
    tags: ["Web Design", "Development", "SEO"],
  },
  {
    id: 2,
    title: "Bloom Wellness Studio",
    category: "Health & Wellness",
    tag: "Sample Project",
    description: "A wellness studio needed a brand-aligned website that could handle online bookings and showcase their services. We built a calming, premium experience that drives class sign-ups.",
    beforeIcon: "ri-layout-grid-line",
    afterIcon: "ri-heart-pulse-line",
    metrics: [
      { label: "Booking Rate", value: "+180%" },
      { label: "Session Duration", value: "+3.2min" },
      { label: "Conversion Rate", value: "8.4%" },
    ],
    tags: ["Web Design", "Booking System", "Branding"],
  },
  {
    id: 3,
    title: "Pinnacle Law Firm",
    category: "Legal Services",
    tag: "Concept Work",
    description: "A prestigious law firm required a website that commanded authority and trust. We crafted a dark, sophisticated design with clear service pages and a streamlined consultation booking flow.",
    beforeIcon: "ri-layout-grid-line",
    afterIcon: "ri-scales-3-line",
    metrics: [
      { label: "Consultation Requests", value: "+320%" },
      { label: "Trust Score", value: "9.8/10" },
      { label: "Organic Traffic", value: "+195%" },
    ],
    tags: ["Web Design", "Development", "Conversion Opt."],
  },
];
